import { useState, useEffect, useMemo } from 'react';

/**
 * Hook to manage a dynamic gradient class based on the time of day.
 * Synchronized with the system clock.
 */
export const useDynamicGradient = () => {
    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 60000); // Update every minute is enough for time-based theme
        return () => clearInterval(timer);
    }, []);

    const gradientClass = useMemo(() => {
        const hour = currentTime.getHours();

        // Define periods
        let timeOfDay;
        if (hour >= 0 && hour < 6) timeOfDay = 'dawn';
        else if (hour >= 6 && hour < 12) timeOfDay = 'morning';
        else if (hour >= 12 && hour < 14) timeOfDay = 'lunch';
        else if (hour >= 14 && hour < 18) timeOfDay = 'afternoon';
        else if (hour === 18) timeOfDay = 'lateAfternoon';
        else timeOfDay = 'night';

        // Map time of day to specific Tailwind gradient classes
        const gradients = {
            dawn: 'from-indigo-400 via-purple-500 to-indigo-400',
            morning: 'from-yellow-200 via-orange-400 to-yellow-200',
            lunch: 'from-cyan-300 via-blue-500 to-cyan-300',
            afternoon: 'from-orange-300 via-amber-500 to-orange-300',
            lateAfternoon: 'from-pink-400 via-orange-500 to-pink-400',
            night: 'from-blue-400 via-indigo-600 to-blue-400'
        };

        return gradients[timeOfDay];
    }, [currentTime.getHours()]);

    return gradientClass;
};
